import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import './styles/App.css'


ReactDOM.render(<App />, document.getElementById('root'));
